export enum ShareEntityType {
    POST = 'post',
    EVENT='event',
    ITEM = 'item',
    PROVIDER = 'provider',
    REQUEST_PROVIDER = 'request',
    BUSINESS = 'business',
    GROUP = 'group',
    COMMENT='comment',
    EDUCATION = 'education',
  }

